import { axiosInstance } from "../../../config/axios";

export const getLineStatus = async (row, page = 1, filters = {}) => {
	try {
		const res = await axiosInstance.get("line-status", {
			params: { page_size: row, page: page, ...filters },
		});
		console.log(res);
		const { data } = res;
		data["success"] = true;
		return data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};
